module.exports = __webpack_public_path__ + "static/media/Jan_2026_3.0d2e8112.webp";